import { UnifiedThemeType as AudiTheme } from '@oneaudi/unified-web-common';

export const isDarkTheme = (theme: AudiTheme): boolean => theme.name === 'dark';
